<template>
  <a-config-provider :locale="i18nLocale.includes('zh') ? zhCN : enUS" :theme="antdTheme">
    <router-view />
    <!-- 机器人是登录后功能：登录页/未登录态不展示 -->
    <chat-bot v-if="showChatBot" />
    <!-- 全局AI任务面板 -->
    <ai-analysis-task-panel />
  </a-config-provider>
</template>

<script setup lang="ts">
import { ConfigProvider as AConfigProvider } from 'ant-design-vue';
import enUS from 'ant-design-vue/es/locale/en_US';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import ChatBot from './views/common/chatBot/index.vue';
import { useChatBotVisibility } from './views/common/chatBot/use-chat-bot-visibility';

const { locale: i18nLocale } = useI18n();

const route = useRoute();
// 登录后才展示机器人：无 token 或处于登录/免登录路由时隐藏（登录 SPA 跳转即时重算，无需刷新）
const showChatBot = useChatBotVisibility(route);

const antdTheme: any = {
  token: {
    colorPrimary: '#1664d8',
    colorInfo: '#1664d8',
    colorLink: '#1664d8',
    borderRadius: 7,
    fontSize: 14,
    colorBgLayout: '#f5f6f8',
    colorBorder: '#e5e6eb',
    colorText: '#1d2129',
    colorTextSecondary: '#4e5969',
    colorTextTertiary: '#6b7178',
    colorTextQuaternary: '#86909c',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif",
  },
  components: {
    Table: {
      headerBg: '#f7f8fa',
      headerColor: '#4e5969',
      headerFontSize: 12,
      headerFontWeight: 600,
      cellFontSize: 14,
      borderColor: '#e5e6eb',
      rowHoverBg: '#f2f3f5',
    },
    Button: { fontWeight: 500 },
    Modal: { borderRadiusLG: 10, titleFontSize: 16 },
    Tag: { borderRadiusSM: 4 },
    Tabs: { inkBarColor: '#1664d8', itemSelectedColor: '#1664d8' },
  },
};

onMounted(() => {
  const savedLocale = localStorage.getItem('locale');
  if (savedLocale) {
    i18nLocale.value = savedLocale;
  }
});

watch(i18nLocale, (val) => {
  localStorage.setItem('locale', val);
  dayjs.locale(val.includes('zh') ? 'zh' : 'en');
});
</script>
